import React, { useCallback, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Wizard } from 'react-use-wizard';
import text from '../../../../text';
import ProjectNameForm from '../../ProjectNameForm';
import { useGetJobQuery } from '../../../../redux/rtk';
import { useRedirect } from '../../../../hooks/useRedirect';
import routes from '../../../../routes/constants';
import { hideModal } from '../../../../redux/actions';

export const MP_SAVE_DRAFT_MODAL = 'MP_SAVE_DRAFT_MODAL';

const MpSaveDraftModal = ({
  jobId,
  show,
  onSubmit,
}: {
  jobId: number;
  show: boolean;
  onSubmit: (values: { projectName?: string | null }) => void;
}) => {
  const redirect = useRedirect();
  const dispatch = useDispatch();
  const { data: job } = useGetJobQuery(jobId);

  const handleHide = useCallback(
    () => dispatch(hideModal(MP_SAVE_DRAFT_MODAL)),
    [dispatch]
  );

  const handleContinue = useCallback(
    (values: { projectName?: string | null }) => {
      onSubmit(values);
      redirect.push(routes.dashboard);
      handleHide();
    },
    [handleHide, onSubmit, redirect]
  );

  return (
    <Modal centered show={show} onHide={handleHide}>
      <Modal.Body>
        <Wizard>
          <>
            <h2 className='text-center w-100'>{text('enterProjectName')}</h2>
            <p className='text-center mb-1'>
              {text('yourProjectSavedAsDraft')}
            </p>
            <p className='text-center'>{text('accessDraftsAnytime')}</p>
            <ProjectNameForm
              // @ts-expect-error no prop
              project={{
                name: job?.project.name,
              }}
              onContinue={(values: any) =>
                handleContinue({ projectName: values.name })
              }
              onCancel={handleHide}
              onContinueText={text('goToDashboard')}
            />
          </>
        </Wizard>
      </Modal.Body>
    </Modal>
  );
};

export default MpSaveDraftModal;
